// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"gJ-z","carouselContainer":"hJ-z"};